import { useCallback } from 'react';
// Keep this order
import 'ace-builds';
import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/theme-twilight';

interface CodeEditorProps {
  defaultValue?: string;
  fontSize?: string | number;
  height?: string;
  onChange: (value: string, event?: any) => void;
  options: any;
  readOnly?: boolean;
  showGutter?: boolean;
  tabSize?: number;
  value?: string;
  wrapEnabled?: boolean;
}

const CodeEditor = ({
  defaultValue,
  fontSize,
  height,
  onChange,
  options,
  readOnly,
  showGutter,
  tabSize,
  wrapEnabled,
  value,
}: CodeEditorProps) => {
  const handleLoad = useCallback(
    // @ts-expect-error untyped
    (instance) => (window.__HB_ACE_EDITOR__ = instance),
    [],
  );

  return (
    <AceEditor
      defaultValue={defaultValue}
      fontSize={fontSize}
      height={height}
      mode="html"
      onChange={onChange}
      onLoad={handleLoad}
      readOnly={readOnly}
      setOptions={{ useWorker: false, ...options }}
      showGutter={showGutter}
      tabSize={tabSize}
      theme="twilight"
      value={value}
      width="100%"
      wrapEnabled={wrapEnabled}
    />
  );
};

CodeEditor.defaultProps = {
  fontSize: 12,
  options: {},
  readOnly: false,
  showGutter: false,
  tabSize: 4,
  wrapEnabled: false,
};

export default CodeEditor;
